export default {"src":"/_next/static/media/clarifayo_FundoPreto.f1d49c8c.svg","height":411,"width":1080,"blurWidth":0,"blurHeight":0};